import { Role } from 'models'
import { checkRoles } from 'utils'
import { destroy as baseDestroy } from 'services/billing'

export async function destroy(id: number | string): Promise<void> {
  await checkRoles([Role.MANAGER, Role.FINANCE])
  await baseDestroy('/access-plans', id)
}
